import { PageSkeleton } from "@plerity/dashboard-shared/components";
import { lazy, Suspense } from "react";

const AppSettings = lazy(() => import("../Settings"));

export function AppSettingsTabContent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <AppSettings />
    </Suspense>
  );
}
